import { GameImportForm } from "@/components/shared/game-import-form";
import { PageCardContainer } from "@/components/shared/page-card/page-card-container";
import { Button } from "@/components/ui/button";
import { getPageSummary, PAGE } from "@/pages";
import { clearDatabase } from "@chesspresso/chess/src/db/db";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/(container)/import")({
    component: RouteComponent,
});

const page = getPageSummary(PAGE.Import);
const isDevelopment = import.meta.env.DEV;

function RouteComponent() {
    return (
        <PageCardContainer
            title={page.title}
            Icon={page.icon}
            description="Import your chess games"
            headerActions={
                isDevelopment ? (
                    <Button
                        className="cursor-pointer"
                        variant="outline"
                        onClick={() => clearDatabase()}
                    >
                        Reset DB
                    </Button>
                ) : null
            }
        >
            <GameImportForm />
        </PageCardContainer>
    );
}
